import { theme, Typography } from "antd";
import { useState } from "react";
import {
  initiateConfirmCompanyPhone,
  initiateConfirmEmail,
  initiateConfirmPhone,
} from "../repository/auth.repository";
import InModal from "../controls/InModal";
import { modalTitle } from "../controls/InModal.default";
import ModalFooter from "../controls/ModalFooter";
import ModalErrorAlert from "../controls/ModalErrorAlert";

export interface InitiateUserProps {
  readonly open?: boolean;
  readonly type: "confirmCompanyPhone" | "confirmPhone" | "confirmEmail";
  readonly initialValues: {
    readonly userUid: string;
    readonly userName: string;
  };
  readonly onFinish?: () => void;
  readonly onCancel?: () => void;
}

function InitiateUserFormDialog(props: InitiateUserProps) {
  const { token } = theme.useToken();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  // Events

  function onSubmit(): void {
    setLoading(true);
    setError(false);
    if (props.type == "confirmEmail") {
      initiateConfirmEmail(props.initialValues.userUid)
        .then(() => {
          setLoading(false);
          props.onFinish?.();
        })
        .catch(() => {
          setLoading(false);
          setError(true);
        });
    } else if (props.type == "confirmPhone") {
      initiateConfirmPhone(props.initialValues.userUid)
        .then(() => {
          setLoading(false);
          props.onFinish?.();
        })
        .catch(() => {
          setLoading(false);
          setError(true);
        });
    } else if (props.type == "confirmCompanyPhone") {
      initiateConfirmCompanyPhone(props.initialValues.userUid)
        .then(() => {
          setLoading(false);
          props.onFinish?.();
        })
        .catch(() => {
          setLoading(false);
          setError(true);
        });
    }
  }

  function onCancel(): void {
    props.onCancel?.();
  }

  function createTitle() {
    switch (props.type) {
      case "confirmEmail":
        return "Email";
      case "confirmPhone":
        return "Phone";
      case "confirmCompanyPhone":
        return "Company Phone";
    }

    return "";
  }

  return (
    <InModal
      open={props.open}
      title={modalTitle(
        "update",
        "User",
        props.initialValues?.userName ?? (props.initialValues as any)?.name,
      )}
      actions={
        <ModalFooter
          mode="update"
          loading={loading}
          onCancel={onCancel}
          onSubmit={onSubmit}
          submitText="Initiate"
        />
      }
      onCancel={onCancel}
      size={"small"}
    >
      <Typography.Paragraph>
        <Typography.Text>
          Continue to initiate {createTitle().toLowerCase()} for{" "}
          <Typography.Text className="font-bold">
            {props.initialValues?.userName}
          </Typography.Text>{" "}
          user?
        </Typography.Text>
      </Typography.Paragraph>
      <ModalErrorAlert
        message={error ? "Something went wrong, try again" : undefined}
      />
    </InModal>
  );
}

export default InitiateUserFormDialog;
